import * as React from 'react';
import useWidget from '@Utils/core/useWidget';
import { WidgetId } from '@Utils/edge/constants';
import { getServerErrorByProp } from '@Utils/shared/utils/getServerErrorByProp';
import { useValidate } from './useValidate';
import { useGetUserId } from '@Utils/shared/hooks/useGetGameUserId';

export interface DownloadLogoFormInput {
  placeholder: string;
  name: string;
  userId: string;
  setUserId: React.Dispatch<React.SetStateAction<string>>;
  error: string;
  clearError: () => void;
}

export function useInputData() {
  const { userId, setUserId } = useGetUserId();
  const { errors, validate, setErrors } = useValidate();

  const downloadThankYouWidget = useWidget(WidgetId.LogoMakerThankYouRaidIdV3);

  const setErrorsFromServer = (error: any) => {
    const errorsFromServer = getServerErrorByProp(error);
    const serverErrorString = errorsFromServer.fullUserId || errorsFromServer.common || '';

    setErrors((prevErrors) => ({
      playerId: serverErrorString || prevErrors.playerId,
    }));
  };

  const clearErrors = React.useCallback(() => {
    setErrors({
      playerId: '',
    });
  }, [setErrors]);

  const input: DownloadLogoFormInput = React.useMemo(() => {
    return {
      name: 'userId',
      placeholder: downloadThankYouWidget.strings.raidIdPlaceholder,
      userId: userId,
      setUserId: setUserId,
      error: errors.playerId,
      clearError: clearErrors,
    };
  }, [
    userId,
    setUserId,
    clearErrors,
    errors.playerId,
    downloadThankYouWidget.strings.raidIdPlaceholder,
  ]);

  return {
    input,
    validate,
    errors,
    setErrorsFromServer,
  };
}
